import React, { Component, useState, useRef, useEffect } from 'react';


import { useTranslation } from 'react-i18next';
import '../99_untils/i18n';
import { openUrl } from '../99_untils/flutterCallback';


import './Footer.css';

import {
  // Navigate,
  // useNavigate,
  Link,
} from 'react-router-dom';

import {
  Button, Container, Row, Col,
  // Card, CardBody, CardTitle, CardSubtitle, CardText 
} from 'reactstrap';

export default function Footer(props) {
  // console.log("Footer constructor started ")
  const isMountedRef = useRef();

  const { t } = useTranslation();
  const { i18n } = useTranslation();
  let curLang = i18n.language;

  const [tarLocation, setTarLocation] = useState("https://www.d-ash.com/");

  const langChangeLink = () => {
    if(curLang === 'en-HK'){
      setTarLocation("https://www.d-ash.com/");
    }else{
      setTarLocation("https://www.d-ash.com/zh");
    }
  }

  useEffect(() => {

      // console.log("Footer curLang changed:", curLang);

    langChangeLink()

    return () => {
    };
  }, [curLang]);


  useEffect(() => {

    isMountedRef.current = true;
    langChangeLink()

    return () => {
      isMountedRef.current = false;
      
      // console.log("Footer unmount")

    };
  }, []);





  return (
    <div className="footer-wrap">
      <div className="footer-inner">
        <div className="footer-text">{t('FooterInfoDashCopy')}</div>
        <Button color='link' size="sm" className='footer-link' title={t('FooterInfoAboutUs')} onClick={() => {
          openUrl(tarLocation, tarLocation);
        }}>
          {t('FooterInfoAboutUs')}
        </Button>
      </div>
    </div>
  );
  // }
}

